import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DateFormetService {
  constructor(private datePipe: DatePipe) { }

  formatDateTime(dateTime: string, format: string = 'dd/MM/yyTHH:mm'): string {
    return this.datePipe.transform(dateTime, format) || '';
  }

  
}
